import type { POI, EnhancedPOIs, School, Schools } from "@local-logic/client";
import { POICategories } from "@local-logic/client";
import type { SDKOptions, MapProviderNames } from "~/types/options";

export type MapProvider = {
  name: MapProviderNames;
  key?: string;
  theme?: string;
};

export type Options = {
  lat?: number;
  lng?: number;
  geographyId?: string;
  zoom?: number;
  pitch?: number;
  bearing?: number;
  cooperativeGestures?: boolean;
  mapProvider?: MapProvider;
  hideAttribution?: boolean;
  showSchoolRatings?: boolean;
};

export type NeighborhoodMapProps = SDKOptions<
  Options,
  {
    options: Options | undefined;
  }
>;

export type POICategory = EnhancedPOIs | keyof Schools;
export type POIGroup = (keyof typeof POICategories)[];
export type SchoolGroup = (keyof Schools)[];
export type Marker = POI | School;

export enum TrackingPipelineEvents {
  SDK_VIEWED = "neighborhood-map-Viewed",
  CATEGORY_CLICKED = "neighborhood-map-Category-Clicked",
  POI_CLICKED = "neighborhood-map-Poi-Clicked",
  POI_LINK_CLICKED = "neighborhood-map-Poi-Link-Clicked",
}

// Why are these named differently?
// https://docs.mixpanel.com/docs/data-structure/events-and-properties#name-events-and-properties-consistently
export enum AnalyticsEvents {
  SDK_VIEWED = "sdk_viewed",
  CATEGORY_CLICKED = "category_clicked",
  POI_CLICKED = "poi_clicked",
  POI_LINK_CLICKED = "poi_link_clicked",
}
